<template>
  <modal v-if="isVisible">
    <template v-slot:header>
      <h5 class="modal-title">{{$t('form.signing.title')}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
        <span aria-hidden="true">
          <img src="@/assets/img/static/b-icon_close_x.svg">
        </span>
      </button>
    </template>

    <template v-slot:body>
      <div>
        <template v-if="file">
          <p>{{$t('form.signing.you-are-going-to-upload-file', {file: file.name})}}</p>
          <p>{{$t('form.signing.you-should-sign-file')}}</p>
        </template>

        <template v-if="text">
          <div class="registration_doc">
            <div v-html="text"></div>
          </div>
        </template>

        <dropdown-new class="select-w-100-percent" v-model="signType">
          <option value="mobile" :label="'sign-type.mobile'"></option>
          <option value="local" :label="'sign-type.local'" :disabled="!hasActiveX"></option>
          <option value="test" :label="'sign-type.test'" v-if="canUseTestSignature"></option>
        </dropdown-new>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" @click.prevent="close" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" @click.prevent="onSignClick" v-t="'buttons.sign'"></button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/widgets/modal'

  const CAPICOM_ENCODE_BASE64 = 0;
  const CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;

  let hasCAPICOM = false;

  try {
    const settings = new ActiveXObject("CAPICOM.Settings");
    //settings.EnablePromptForCertificateUI = true;
    hasCAPICOM = true;
  }
  catch(e) {}

  function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  export default {
    components: {
      Modal
    },

    data: () => ({
      signType: 'mobile',
      isVisible: false,
      popup: undefined,
      hash: undefined,
      code: undefined,
      file: undefined,
      text: undefined
    }),

    computed: {
      hasActiveX() {
        return hasCAPICOM;
      },

      canUseTestSignature() {
        return process.env.NODE_ENV != 'production' || this.permissions.IS_MTS_USER;
      },

      permissions() {
        return _.get(this.$store.getters.currentUser ,'permissions', {});
      },
    },

    methods: {
      open({ hash, file, text }) {
        this.hash = hash !== undefined ? hash + '' : undefined;
        this.code = Array.from({length: 6}).map(() => Math.trunc(Math.random() * 10)).join('');
        this.file = file;
        this.text = text;
        this.isVisible = true;
      },

      close() {
        this.isVisible = false;
        this.$emit('close');
      },

      onSignClick() {
        if (this.signType === 'test') {
          this.dummySign();
        }
        else if (this.signType === 'mobile') {
          this.signWithMobile();
        }
        else {
          this.signWithKey();
        }
      },

      async dummySign() {
        this.$emit('signed', {
          data: this.hash || this.text,
          signature: ''
        });
      },

      async signWithMobile() {
        if (this.signType !== 'mobile') return;

        this.runBlockerAction(async() => {
          try {
            const data = this.hash || this.text;

            const handle = await this.$store.dispatch('initiateSigning', {
              hash: data,
              code: this.code
            });

            this.popup = window.open(handle.url, 'sign-dialog', 'menubar=no,toolbar=no,location=no,status=no,left=0,top=0,width=800,height=450');

            while (this.isVisible && !this.popup.closed) {
              //console.log(this.popup.closed, this.isVisible);

              const result = await this.$store.dispatch('checkSigning', { code: this.code });

              if (result.status === 'pending' || result.status === 'authenticate') {
                await timeout(3000);
                continue
              }
              else if (result.status === 'badToken') {
                console.error('unable to sign with mobile due to bad token', e);

                this.showError({
                  title: 'form.signing.signing-error',
                  error: 'form.signing.signing-error'
                });
                break;
              }
              else if (result.status === 'error') {
                this.showError({
                  title: 'form.signing.signature-validation-error',
                  error: 'errors.unknown'
                });
                break;
              }
              else if (result.status === 'cancelled') {
                this.showError({
                  title: 'form.signing.cancelled-operation',
                  error: 'form.signing.operation-was-cancelled'
                });
                break;
              }
              else if (result.status === 'success') {
                this.$emit('signed', {
                  data: data,
                  signature: result.signature
                });
                break;
              }
            }
          }
          catch(e) {
            console.error('unable to sign with mobile', e);
            this.globalErrorHandler(e);
          }

          if (this.popup) {
            this.popup.close();
          }
        });
      },

      async signWithKey() {
        this.runBlockerAction(async() => {
          try {
            const data = this.hash || this.text;

            const TimeAttribute = new ActiveXObject("CAPICOM.Attribute");

            TimeAttribute.Name = CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME;
            TimeAttribute.Value = new Date().getVarDate();

            const Signer = new ActiveXObject("CAPICOM.Signer");
            Signer.AuthenticatedAttributes.Add(TimeAttribute);

            const SignedData = new ActiveXObject("CAPICOM.SignedData");
            SignedData.Content = data;

            const signature = SignedData.Sign(Signer, true, CAPICOM_ENCODE_BASE64);

            this.$emit('signed', {
              data: data,
              signature
            });
          }
          catch (e) {
            console.error('unable to sign data with certificate', e);

            this.showError({
              error: 'form.signing.failed-signature-generation'
            });
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .registration_doc {
    background-color: #f7f7f7;
    padding: 20px;
    margin-bottom: 20px;

    &>div {
      max-height: 200px;
      overflow-y: auto;
    }
  }
</style>
